import { localStorageSafe } from '../utils/index'

export const SUCCESS_MSG = 'Success'
export const ERROR_MSG = 'Error'

const axios = require('axios')

// export const BASE_URL = process.env.API_URL || 'https://api.run24hrs.com/'
export const BASE_URL = 'https://api.run24hrs.com/'
// export const BASE_URL = 'http://localhost:8000/'
// export const BASE_URL = "http://localhost:8080/"

if (localStorageSafe && localStorage.getItem('run-24-hrs-token')) {
  const token = localStorage.getItem('run-24-hrs-token')
  axios.defaults.headers.common = { Authorization: `Token ${token}` }
}



// WEBPACK FOOTER //
// /opt/build/repo/src/api/index.js